import * as angular from "angular";
import {IController} from "angular";
import {GeofenceLocationType} from "../../models/geofence-zone.model";

export class geofenceZonesListItemCtrl implements IController {

  geofenceZonesListCtrl: any;
  feature: any;
  isSelected: boolean;
  locationType: GeofenceLocationType;

  noLocationLabel: string;

  $onChanges(changes) {
    if (changes.locationType) {
      this.noLocationLabel = this._getNoLocationLabel();
    }
  }

  private _getNoLocationLabel(): string {
    switch (this.locationType) {
      case GeofenceLocationType.ACCOUNT:
        return 'No Account';
      case GeofenceLocationType.DEPOT:
        return 'No Depot';
      default:
        return 'No Location';
    }
  }

}

angular
  .module('bringoz.admin.service-areas')
  .component('geofenceZonesListItem', {
    require: {
      geofenceZonesListCtrl: '^geofenceZonesList'
    },
    bindings: {
      feature: '<',
      isSelected: '<',
      locationType: '<'
    },
    template: require('./geofence-zones-list-item.html').default,
    controller: geofenceZonesListItemCtrl
  });
